"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("@sensechat/crypto-interceptor/key/index");
const token_1 = require("../token");
const CODE_BASE = 1000000;
let refreshCount = 0;
let refreshTimer = null;
const senseFetch = async (...args) => {
    // if (TARGET === 'web') {
    //     const crossStorage = window.__sensecommon.cs
    //     if (!crossStorage.isReady) {
    //         throw Error('crosssStorage is not ready yet, make sure to use senseFetch and senseAxios after crossStorage ready')
    //     }
    // }
    let [url, config] = args;
    if (!config.headers)
        config.headers = {};
    const accesstoken = await (0, token_1.getToken)("accessToken");
    config.headers["Authorization"] = `Bearer ${accesstoken ?? ""}`;
    const response = await fetch(url, config);
    if (response.status === 401) {
        const parsedResponse = await response.json();
        console.log("fetch 401 response: ", JSON.stringify(parsedResponse));
        const isHK = location.pathname.indexOf("/hk") > -1;
        if (refreshCount < 5) {
            refreshCount++;
            clearTimeout(refreshTimer);
            refreshTimer = setTimeout(() => {
                refreshCount = 0;
            }, 10000);
            // 非token失效
            if (parsedResponse.code % CODE_BASE !== 150004) {
                // 重新登录
                await Promise.all([
                    (0, token_1.setToken)("accessToken", ""),
                    (0, token_1.setToken)("refreshToken", ""),
                ]);
                if (TARGET === "web") {
                    console.log("非token失效 重新登录");
                    if (!window.__sensecommon?.isReloading) {
                        window.__sensecommon.isReloading = true;
                        location.href = `${location.origin}${isHK ? "/hk" : ""}/login`;
                    }
                }
                return;
            }
            const res = await fetch(`${location.origin}${isHK ? "/hk/" : "/"}api/auth/v2.1.0/refresh`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                },
                body: JSON.stringify({
                    access: await (0, token_1.getToken)("accessToken"),
                    refresh: await (0, token_1.getToken)("refreshToken"),
                }),
            });
            if (res.status === 401) {
                // 重新登录
                await Promise.all([
                    (0, token_1.setToken)("accessToken", ""),
                    (0, token_1.setToken)("refreshToken", ""),
                ]);
                if (TARGET === "web") {
                    console.log("refresh 401 重新登录");
                    if (!window.__sensecommon?.isReloading) {
                        window.__sensecommon.isReloading = true;
                        location.href = `${location.origin}${isHK ? "/hk" : ""}/login`;
                    }
                }
                return;
            }
            else {
                // 重新请求
                const { message: { access, refresh }, } = await res.json();
                console.log("refresh access", access, refresh);
                const nextAccessToken = access;
                const nextRefreshToken = refresh;
                await Promise.all([
                    (0, token_1.setToken)("accessToken", nextAccessToken),
                    nextRefreshToken
                        ? (0, token_1.setToken)("refreshToken", nextRefreshToken)
                        : Promise.resolve(),
                ]);
                const nextPayload = {
                    ...config,
                    headers: {
                        ...(config.headers || {}),
                        Authorization: `Bearer ${nextAccessToken ?? ""}`,
                    },
                };
                if (config.body) {
                    const params = JSON.parse(config.body);
                    nextPayload.body = await index_1.Crypto.decrypt(params.__data__);
                }
                const nextResponse = await fetch(url, nextPayload);
                return nextResponse;
            }
        }
        else {
            throw Error("refresh too often");
        }
    }
    else {
        return response;
    }
};
exports.default = senseFetch;
